import React from "react";
import { actionCreators } from "../redux/serviceBookingsSagas";
import { useSelector, useDispatch } from "react-redux";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { selectChartControlsDisabled } from "../redux/serviceBookingsSelectors";

const ShowPercentageToggle = () => {
  const dispatch = useDispatch();
  const show_percentage = useSelector((state) => state.serviceBookings.show_percentage);
  const showPercentageToggle = useSelector((state) => state.serviceBookings.showPercentageToggle);
  // Refetches the heatmap without the Update button, so it must be inert whenever Update is.
  const disabled = useSelector(selectChartControlsDisabled);

  return showPercentageToggle ? (
    <div className="service-bookings-toggle" style={disabled ? { cursor: "not-allowed" } : undefined}>
      <p>Show percentage</p>

      <div {...(disabled ? { inert: "" } : {})}>
        <ToggleableButton
          title="Show percentage"
          isRadio
          isActive={show_percentage}
          onClick={(isActive) => dispatch(actionCreators.onChangePercentageToggle(isActive))}
        />
      </div>
    </div>
  ) : null;
};

export default ShowPercentageToggle;
